"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var layout_1 = require("../../layout");
var input_1 = require("../../input");
var Options_1 = __importDefault(require("./Options"));
var TimePicker_1 = require("./TimePicker");
var utils_1 = require("./utils");
var variables_1 = require("../../../style/variables");
var hooks_1 = require("../../../hooks");
var styles = {
    container: react_1.css({
        paddingTop: 8,
        backgroundColor: "var(" + variables_1.RootColor.White + ")",
        border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_4 + ")",
        borderRadius: "var(" + variables_1.BorderRadius.sm + ")",
        boxShadow: "var(" + variables_1.Shadow.xl + ")",
    }),
    footer: react_1.css({
        padding: '16px 12px',
        borderTop: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_3 + ")",
    }),
};
var HOURS_12 = __spreadArrays(['12'], utils_1.getOptions(12).slice(1));
var HOURS_24 = utils_1.getOptions(24);
var MINUTES = utils_1.getOptions(60);
var SECONDS = MINUTES;
var AM_AND_PM = ['AM', 'PM'];
var Popover = function (props) {
    var onRequestClose = props.onRequestClose, use12Hours = props.use12Hours;
    var _a = hooks_1.useDerivedState(function () { return props.time; }, [props.time]), time = _a[0], setTime = _a[1];
    var hours = time.hours, minutes = time.minutes, seconds = time.seconds, amPm = time.amPm;
    var handleOnSelect = function (type) { return function (value) {
        setTime(function (prevTime) {
            var _a;
            return (__assign(__assign({}, prevTime), (_a = {}, _a[type] = value, _a)));
        });
    }; };
    return (react_1.jsx(layout_1.Flex, { direction: "column", css: styles.container },
        react_1.jsx(layout_1.Flex, null,
            react_1.jsx(Options_1.default, { options: use12Hours ? HOURS_12 : HOURS_24, selected: hours, onSelect: handleOnSelect(TimePicker_1.Type.HOUR) }),
            react_1.jsx(Options_1.default, { options: MINUTES, selected: minutes, onSelect: handleOnSelect(TimePicker_1.Type.MINUTE) }),
            react_1.jsx(Options_1.default, { options: SECONDS, selected: seconds, onSelect: handleOnSelect(TimePicker_1.Type.SECOND) }),
            use12Hours && (react_1.jsx(Options_1.default, { options: AM_AND_PM, selected: amPm, onSelect: handleOnSelect(TimePicker_1.Type.AM_PM) }))),
        react_1.jsx(layout_1.Flex, { css: styles.footer, justifyContent: "space-between" },
            react_1.jsx(input_1.Button, { css: { color: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")" }, variant: "flush", size: "small", onClick: function () { return onRequestClose(utils_1.getCurrentTime()); } }, "Now"),
            react_1.jsx(input_1.Button, { size: "small", onClick: function () { return onRequestClose(time); } }, "Ok"))));
};
exports.default = Popover;
